import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H1 from "../../h1/h1.js"
import { QRCodeModalProvider } from "../../qrcodeModal/qrcodeModalContext.js";
import QRCodeModalButton from "../../qrcodeModal/qrcodeModalButton.js";

import styles from "./hero.module.scss"

const HeroSection = () => {
  const data = useStaticQuery(graphql`
    query {
      heroPhoneImage: file(relativePath: { eq: "home/hero-full.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 650
            placeholder: NONE
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <PageSection
      backgroundColor="#eff3f9"
      centerVertical
      collapseAt='large'
      rootStyles={styles.heroContainer}
      RightComponent={() =>
        <div className={styles.heroImgContainer}>
          <GatsbyImage
            image={getImage(data.heroPhoneImage)}
            alt="Two mobile phones standing side-by-side, one showing the Till application from the parent's point of view, and the other from the child's."
            width={650}
          />
        </div>
      }
    >
      <div className={styles.heroCopyContainer}>
        <H1 className={styles.h1}>
          Till builds smarter spenders.
        </H1>
        <h2 className={styles.h3}>
          With Till’s fee-free app and debit card, kids can develop money habits that prepare them for the real world.
        </h2>

        <div className={styles.primaryCta}>
          <QRCodeModalProvider>
            <div className={styles.textToDownloadContainer}>
              <div className={styles.textToDownloadButton}>
                <QRCodeModalButton eventLabel="Home Page - Hero" />
              </div>
            </div>
          </QRCodeModalProvider>
        </div>
      </div>
    </PageSection>
  )
}

export { HeroSection }
